module.exports = __webpack_public_path__ + "img/head.f2915031.png";